/* Maison Velours — comportements globaux (menu mobile, accordéons, apparitions) */
(function () {
  'use strict';

  var focusTrapStack = [];

  function lockScroll(lock) {
    document.body.classList.toggle('is-locked', lock);
  }

  window.MV = window.MV || {};

  window.MV.openPanel = function (el) {
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    lockScroll(true);
    focusTrapStack.push(document.activeElement);
    var focusable = el.querySelector('[data-drawer-focus], button, a[href], input, select');
    if (focusable) focusable.focus();
  };

  window.MV.closePanel = function (el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (el.dataset.opener) {
      var trigger = document.querySelector('[data-open="' + el.dataset.opener + '"]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }
    if (!document.querySelector('.drawer.is-open, .mobile-menu.is-open')) lockScroll(false);
    var previous = focusTrapStack.pop();
    if (previous && previous.focus) previous.focus();
  };

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-open]');
    if (opener) {
      var target = document.querySelector(opener.getAttribute('data-open'));
      /* Si le panneau n'existe pas, on laisse le lien naviguer normalement
         (le panier reste un vrai lien vers /cart). */
      if (target) {
        event.preventDefault();
        opener.setAttribute('aria-expanded', 'true');
        target.dataset.opener = opener.getAttribute('data-open');
        window.MV.openPanel(target);
      }
      return;
    }

    var closer = event.target.closest('[data-close]');
    if (closer) {
      event.preventDefault();
      window.MV.closePanel(closer.closest('.drawer, .mobile-menu'));
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelector('.drawer.is-open, .mobile-menu.is-open');
    if (open) window.MV.closePanel(open);
  });

  /* Accordéons (FAQ, onglets produit) */
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.accordion__trigger');
    if (!trigger) return;
    var panel = document.getElementById(trigger.getAttribute('aria-controls'));
    var expanded = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', String(!expanded));
    if (panel) panel.classList.toggle('is-open', !expanded);
  });

  /* Apparition progressive au défilement */
  function initReveal() {
    var items = document.querySelectorAll('.reveal:not(.is-visible)');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (i) { i.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    items.forEach(function (item) { observer.observe(item); });
  }

  initReveal();
  document.addEventListener('shopify:section:load', initReveal);

  /* Sous-menus accessibles au clavier sur mobile */
  document.querySelectorAll('[data-mobile-submenu-toggle]').forEach(function (button) {
    button.addEventListener('click', function () {
      var list = button.nextElementSibling;
      if (!list) return;
      var open = list.hasAttribute('hidden');
      if (open) { list.removeAttribute('hidden'); } else { list.setAttribute('hidden', ''); }
      button.setAttribute('aria-expanded', String(open));
    });
  });
})();
